<template lang="pug">
.seller-records
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (action selector)
      ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      template(v-if='actionType')
        template(v-if='actionType === "SELL_HISTORY"')
          SellerChooser(
            @input='selectSeller'
          )
        template(v-else-if='actionType === "OVERALL_STAT"')
          .d-flex
            LeaderBoardPanel
            OverallStatPanel
        template(v-else-if='actionType === "UPLOAD"')
          UploadPanel

    transition(name='simple-fade' mode='out-in')
      //- STEP 3 (visible if item is selected)
      template(v-if='currentStep >= STEP_SELECT_ITEM')
        template(v-if='actionType === "SELL_HISTORY" && selectedSeller')
          .d-flex
            GoalsPanel(:seller='selectedSeller')
            //- GoalsHistoryPanel(:seller='selectedSeller')
            //- Remove for now

</template>

<script>
import SellerChooser from '@/components/_admin/seller-records/panels/history/SellerChooser.vue';
import GoalsPanel from '@/components/_admin/seller-records/panels/history/GoalsPanel.vue';
import GoalsHistoryPanel from '@/components/_admin/seller-records/panels/history/GoalsHistoryPanel.vue';
// import ViewPanel from '@/components/_admin/seller-records/panels/ViewPanel.vue';

import LeaderBoardPanel from '@/components/profile-performance/panels/LeaderBoardPanel.vue';
import OverallStatPanel from '@/components/_admin/seller-records/panels/overall/OverallStatPanel.vue';

import UploadPanel from '@/components/_admin/seller-records/panels/upload/UploadPanel.vue';

export default {
  data: () => ({
    actionType: null,
    selectedSeller: null,

    currentStep: 0,

    STEP_SELECT_ACTION: 1,
    STEP_SELECT_ITEM: 2,
    STEP_PERFORM_ACTION: 3,

    actionItems: {
      SELL_HISTORY: 'ดูประวัติเซลล์',
      OVERALL_STAT: 'สถิติการแข่งขัน',
      UPLOAD: 'ตั้งเป้าเซลล์',
    },
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }

        // STEP 2
        if (step < this.STEP_SELECT_ITEM) {
          this.selectedSeller = null;
        }
      }, 50);
    },

    selectSeller(e) {
      // eslint-disable-next-line
      this.selectedSeller = e[0];
      this.setCurrentStep(this.STEP_SELECT_ITEM);
    },
  },
  components: {
    SellerChooser,
    GoalsPanel,
    GoalsHistoryPanel,

    LeaderBoardPanel,
    OverallStatPanel,

    UploadPanel,
  },
};
</script>

<style lang="scss">
.seller-records {
  > .h-scroll {
    height: 100%;
  }
}
</style>
